import Image from 'next/image';
import { ICONS, type BadgeSize } from './securityicons';

const WIDTHS: Record<'default' | 'spacious', Record<BadgeSize, string>> = {
  default: {
    sm: 'clamp(40px, 15vw, 140px)',
    lg: 'clamp(56px, 19vw, 220px)',
    xl: 'clamp(64px, 22vw, 280px)',
  },
  spacious: {
    sm: 'clamp(52px, 13vw, 90px)',
    lg: 'clamp(80px, 20vw, 140px)',
    xl: 'clamp(100px, 26vw, 180px)',
  },
};

export default function SecurityBadges({
  className = '',
  variant = 'default',
}: {
  className?: string;
  variant?: 'default' | 'spacious';
}) {
  const isSpacious = variant === 'spacious';

  return (
    <div className={`w-full ${className}`}>
      <div
        className={`text-center uppercase tracking-wide text-gray-500 transition-all ${
          isSpacious
            ? 'text-sm mb-10 font-medium tracking-wider'
            : 'text-xs font-medium mb-4'
        }`}
      >
        Security & Compliance certifications in progress
      </div>
      <ul
        className={`flex justify-center items-center transition-all w-full ${
          isSpacious
            ? 'flex-wrap md:flex-nowrap gap-4 md:gap-8'
            : 'flex-nowrap gap-1 md:gap-3'
        }`}
      >
        {Object.entries(ICONS).map(([label, badge]) => (
          <li
            key={label}
            className="flex items-center px-0.5 md:px-3 bg-transparent"
            title={badge.certDescription}
          >
            <Image
              src={badge.image}
              alt={badge.certName}
              width={140}
              height={140}
              className="mix-blend-multiply object-contain max-w-full"
              style={{
                backgroundColor: 'transparent',
                mixBlendMode: 'multiply',
                width: WIDTHS[isSpacious ? 'spacious' : 'default'][badge.size],
                height: 'auto',
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
